(function(){'use strict';var CFG,lastSig='',CART_QTY=0,CART_BASE=0,PRICES={p:{},c:{}};
function cfg(){var e=document.getElementById('vc-cro-config');var d=e?e.dataset:{};return{
  duties:d.duties!=='false',dutiesText:d.dutiesText||'',
  dutiesGeo:d.dutiesGeo==='true',
  dutiesUS:d.dutiesUs||'',dutiesCA:d.dutiesCa||'',dutiesUK:d.dutiesUk||'',
  dutiesHideOther:d.dutiesHideOther!=='false',
  country:(d.country||'').toUpperCase(),
  trust:d.trust!=='false',trustText:d.trustText||'',trustIcon:d.trustIcon||'heart',
  badges:d.badges!=='false',badge1:d.badge1||'',badge2:d.badge2||'',badge3:d.badge3||'',
  great:d.great!=='false',greatText:d.greatText||'GREAT CHOICE!',
  vol:d.vol!=='false',
  t2:parseInt(d.t2||'10'),t3:parseInt(d.t3||'15'),t4:parseInt(d.t4||'20'),
  q2:parseInt(d.q2||'2'),q3:parseInt(d.q3||'3'),q4:parseInt(d.q4||'4'),
  xvar:d.xvar!=='false',pid:d.pid||'',
  showSaved:d.volSaved==='true',baseSource:d.volBase||'price',
  savedLabel:d.savedLabel||'You saved {amount}.',
  maxLabel:d.maxLabel||'Maximum saving unlocked',
  currency:d.currency||'USD',locale:d.locale||'en',
  sd:d.sd!=='false',sm:d.sm!=='false',atcLabel:d.atcLabel||'ADD TO CART'};}

var ICONS={
  ship:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2"/><path d="M14 9h4l4 4v4a1 1 0 0 1-1 1h-1"/><circle cx="6.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/><path d="M8.5 18h7"/></svg>',
  ret:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>',
  lock:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="1.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/><circle cx="12" cy="15.5" r="1"/></svg>',
  arrow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>',
  shield:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="12" height="12" style="opacity:.55"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
  heart:'<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" width="12" height="12" style="opacity:.7"><path d="M12 21s-7.5-4.6-9.6-9A5.4 5.4 0 0 1 12 6.3 5.4 5.4 0 0 1 21.6 12c-2.1 4.4-9.6 9-9.6 9z"/></svg>',
  heartOutline:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="12" height="12" style="opacity:.7"><path d="M12 20.5s-7.2-4.4-9.2-8.6A5.2 5.2 0 0 1 12 6.6a5.2 5.2 0 0 1 9.2 5.3c-2 4.2-9.2 8.6-9.2 8.6z"/></svg>'
};

function trustIcon(){
  var k=CFG&&CFG.trustIcon?CFG.trustIcon:'heart';
  if(k==='heart')return ICONS.heart;
  if(k==='heart_outline')return ICONS.heartOutline;
  if(k==='shield')return ICONS.shield;
  if(k==='none')return '';
  return ICONS.heart;
}

function qtyInputs(){return document.querySelectorAll('input[name="quantity"],.quantity__input,.js-qty__num,[data-quantity-input]');}
function getQty(){var list=qtyInputs();for(var i=0;i<list.length;i++){if(list[i].offsetParent!==null||list.length===1){var v=parseInt(list[i].value);if(!isNaN(v)&&v>0)return v;}}
  var s=document.getElementById('vc-sticky-qty');if(s){var sv=parseInt(s.textContent);if(!isNaN(sv))return sv;}
  return 1;}
function setQty(n){var list=qtyInputs();Array.prototype.forEach.call(list,function(i){i.value=n;i.dispatchEvent(new Event('input',{bubbles:true}));i.dispatchEvent(new Event('change',{bubbles:true}));});}
function totalQty(){if(!CFG||!CFG.xvar)return getQty();return CART_QTY;}
function atc(){return document.querySelector('[name="add"],.product-form__submit,button[data-add-to-cart],.wt-button--add-to-cart');}
function mk(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html)e.innerHTML=html;return e;}
function tiers(){return[{q:CFG.q2,p:CFG.t2,at:33.333},{q:CFG.q3,p:CFG.t3,at:66.666},{q:CFG.q4,p:CFG.t4,at:100}];}

/* ---------- Duties notice: country aware ---------- */
function dutiesText(){
  if(!CFG.dutiesGeo)return CFG.dutiesText;
  var c=(window.__vcCountry||'').toUpperCase();
  if(!c)return '';
  if(c==='US'||c==='USA')return CFG.dutiesUS||CFG.dutiesText;
  if(c==='CA'||c==='CAN')return CFG.dutiesCA||CFG.dutiesText;
  if(c==='GB'||c==='UK'||c==='GBR')return CFG.dutiesUK||CFG.dutiesText;
  return CFG.dutiesHideOther?'':CFG.dutiesText;
}
function applyDuties(){
  var n=document.querySelector('.vc-duties-notice');if(!n)return;
  var t=dutiesText();
  var sp=n.querySelector('span');if(sp)sp.textContent=t;
  n.style.display=t?'':'none';
}
function setCountry(c){
  window.__vcCountry=String(c||'').toUpperCase();
  applyDuties();
}
function detectCountry(){
  if(!CFG||!CFG.duties)return;
  if(!CFG.dutiesGeo){applyDuties();return;}
  if(window.__vcCountry){applyDuties();return;}
  if(!window.fetch){setCountry(CFG.country);return;}
  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',{credentials:'same-origin',headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(j){
      var d=j&&j.detected_values&&j.detected_values.country;
      var c=d&&(d.handle||d.iso_code||d.code);
      setCountry(c||CFG.country);})
    .catch(function(){setCountry(CFG.country);});
}

/* ---------- Prices / money ---------- */
function loadPrices(){var e=document.getElementById('vc-cro-prices');if(!e)return;
  try{var j=JSON.parse(e.textContent||'{}');PRICES={p:j.p||{},c:j.c||{}};}catch(x){}}
function currentVariantId(){
  var f=document.querySelector('form[action*="/cart/add"] [name="id"]');
  if(f&&f.value)return String(f.value);
  var m=location.search.match(/[?&]variant=(\d+)/);return m?m[1]:'';}
function unitPrice(){
  var id=currentVariantId(),k;
  if(CFG.baseSource==='compare'&&id&&PRICES.c[id])return PRICES.c[id];
  if(id&&PRICES.p[id]!=null)return PRICES.p[id];
  for(k in PRICES.p){return PRICES.p[k];}
  return 0;}
function baseTotal(){
  if(CFG.xvar&&CART_QTY>0&&CART_BASE>0)return CART_BASE;
  return unitPrice()*Math.max(1,totalQty()||getQty());}
function money(cents){
  var v=(cents||0)/100;
  try{return new Intl.NumberFormat(CFG.locale||'en',{style:'currency',currency:CFG.currency||'USD',minimumFractionDigits:(v%1===0?0:2),maximumFractionDigits:2}).format(v);}
  catch(e){return '$'+v.toFixed(2);}}

function refreshCart(){if(!CFG||!CFG.xvar||!CFG.pid){CART_QTY=0;CART_BASE=0;lastSig='';update();return;}
  if(!window.fetch)return;
  fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){var n=0,b=0;(c.items||[]).forEach(function(it){
        if(String(it.product_id)!==String(CFG.pid))return;
        n+=it.quantity;
        var unit;
        if(CFG.baseSource==='compare'&&PRICES.c[String(it.variant_id)])unit=PRICES.c[String(it.variant_id)];
        else unit=(it.original_price!=null?it.original_price:it.price);
        b+=unit*it.quantity;});
      CART_QTY=n;CART_BASE=b;lastSig='';update();})
    .catch(function(){});}

function duties(anchor){if(!CFG.duties||document.querySelector('.vc-duties-notice'))return;
  var t=CFG.dutiesGeo?'':dutiesText();
  if(!CFG.dutiesGeo&&!t)return;
  var el=mk('div','vc-duties-notice',ICONS.arrow+'<span>'+esc(t)+'</span>');
  if(!t)el.style.display='none';
  anchor.parentNode.insertBefore(el,anchor);}

function badges(anchor){if(!CFG.badges||document.querySelector('.vc-badges'))return;
  var items=[[ICONS.ship,CFG.badge1],[ICONS.ret,CFG.badge2],[ICONS.lock,CFG.badge3]].filter(function(x){return x[1];});
  if(!items.length)return;
  var html=items.map(function(x){return'<div class="vc-badge">'+x[0]+'<span>'+x[1]+'</span></div>';}).join('');
  anchor.parentNode.insertBefore(mk('div','vc-badges',html),anchor.nextSibling);}

function trust(anchor){if(!CFG.trust||!CFG.trustText||document.querySelector('.vc-trust-text'))return;
  var b=document.querySelector('.vc-badges');
  var ref=b?b.nextSibling:anchor.nextSibling;
  anchor.parentNode.insertBefore(mk('div','vc-trust-text',trustIcon()+'<span>'+CFG.trustText+'</span>'),ref);}

function volbar(anchor){if(!CFG.vol||document.querySelector('.vc-vol'))return;
  var dots=tiers().map(function(t){return'<span class="vc-vol__step" data-qty="'+t.q+'" style="left:'+t.at+'%"><b class="vc-vol__pct">'+t.p+'%</b><i class="vc-vol__dot"></i></span>';}).join('');
  var el=mk('div','vc-vol','<div class="vc-vol__track"><div class="vc-vol__fill" id="vc-vol-fill"></div>'+dots+'</div><div class="vc-vol__msg" id="vc-vol-msg"></div>');
  anchor.parentNode.insertBefore(el,anchor);
  lastSig='';update();refreshCart();}

function esc(t){return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}

function update(){if(!CFG||!CFG.vol)return;
  var q=totalQty();
  var base=CFG.showSaved?baseTotal():0;
  var sig=q+'|'+base;
  if(sig===lastSig)return;lastSig=sig;
  var f=document.getElementById('vc-vol-fill'),m=document.getElementById('vc-vol-msg');if(!f||!m)return;
  var ts=tiers();
  Array.prototype.forEach.call(document.querySelectorAll('.vc-vol__step'),function(t){
    t.classList.toggle('active',q>=parseInt(t.dataset.qty));});
  var last=-1;for(var i=0;i<ts.length;i++){if(q>=ts[i].q)last=i;}
  var pct,msg,nextMsg;
  if(last<0){
    pct=q<=0?0:(q/ts[0].q)*ts[0].at;
    if(q<=0){msg='Add any '+ts[0].q+' colors to unlock '+ts[0].p+'% off';nextMsg=msg;}
    else{var n=Math.max(1,ts[0].q-q);
      msg='Add '+n+' more color'+(n>1?'s':'')+' to unlock '+ts[0].p+'% off';nextMsg=msg;}
  }
  else if(last===ts.length-1){pct=ts[last].at;msg=ts[last].p+'% off unlocked — maximum saving';nextMsg=CFG.maxLabel;}
  else{pct=ts[last].at;var need=Math.max(1,ts[last+1].q-q);
    msg=ts[last].p+'% off unlocked. Add '+need+' more for '+ts[last+1].p+'% off';
    nextMsg='Add '+need+' more for '+ts[last+1].p+'% off';}
  f.style.width=pct+'%';
  if(!CFG.showSaved){m.textContent=msg;}
  else{
    var html='';
    if(last>=0){
      var amt=Math.round(base*ts[last].p/100);
      if(amt>0)html+='<span class="vc-vol__saved">'+esc(CFG.savedLabel.replace('{amount}',money(amt)))+'</span> ';
    }
    html+='<span class="vc-vol__next">'+esc(nextMsg)+'</span>';
    m.innerHTML=html;
  }
  var s=document.getElementById('vc-sticky-qty');if(s)s.textContent=getQty();}

function great(b){if(!CFG.great||b.dataset.vcW)return;b.dataset.vcW='1';
  b.addEventListener('click',function(){if(b.disabled)return;
    setTimeout(function(){if(b.disabled)return;
      var t=b.querySelector('.btn__text,.product-form__submit-label')||b;
      var o=t.textContent.trim();
      t.textContent='✓  '+CFG.greatText;
      b.style.animation='vcGreatPop .45s ease';
      setTimeout(function(){t.textContent=o;b.style.animation='';},2400);},350);});}

function sticky(){
  var t=document.querySelector('.product__title,h1.title,.product-title,h1');
  var i=document.querySelector('.wt-product__img,.product__media img,.product-featured-media img');
  var p=document.querySelector('.price__current,.product__price,[data-product-price],.price-item--regular');
  var title=t?t.textContent.trim():'',img=i?(i.src||'').split('?')[0]:'',price=p?p.textContent.trim():'';
  if(CFG.sd&&!document.getElementById('vc-sticky-bar')){
    var b=mk('div','vc-sticky-bar','<div class="vc-sticky-bar__inner">'+(img?'<img class="vc-sticky-bar__thumb" src="'+img+'" alt="">':'')+'<div style="flex:1;min-width:0"><div class="vc-sticky-bar__name">'+title+'</div><div class="vc-sticky-bar__variant" id="vc-sticky-variant"></div></div><div class="vc-sticky-bar__price" id="vc-sticky-price">'+price+'</div><div class="vc-sticky-bar__qty"><button type="button" onclick="vcQty(-1)">−</button><span id="vc-sticky-qty">1</span><button type="button" onclick="vcQty(1)">+</button></div><button class="vc-sticky-bar__atc" type="button" onclick="vcATC()">'+CFG.atcLabel+'</button></div>');
    b.id='vc-sticky-bar';document.body.appendChild(b);
    var a=atc();if(a)window.addEventListener('scroll',function(){b.classList.toggle('visible',a.getBoundingClientRect().bottom<0);},{passive:true});}
  if(CFG.sm&&!document.getElementById('vc-mobile-sticky')){
    var m=mk('div','vc-mobile-sticky',(img?'<img class="vc-mobile-sticky__thumb" src="'+img+'" alt="">':'')+'<div class="vc-mobile-sticky__info"><div class="vc-mobile-sticky__variant" id="vc-mob-variant"></div><div class="vc-mobile-sticky__price" id="vc-mob-price">'+price+'</div></div><button class="vc-mobile-sticky__atc" type="button" onclick="vcATC()">'+CFG.atcLabel+'</button>');
    m.id='vc-mobile-sticky';document.body.appendChild(m);document.body.classList.add('vc-mobile-active');}
  vcSync();}

window.vcSync=function(){
  var p=document.querySelector('.price__current,.product__price,[data-product-price],.price-item--regular');
  var v=document.querySelector('.product__variant-title,.wt-product__selected-variant,[data-current-variant]');
  var i=document.querySelector('.wt-product__gallery .swiper-slide-active img,.wt-product__img');
  var pt=p?p.textContent.trim():'',vt=v?v.textContent.trim():'',im=i?(i.src||'').split('?')[0]:'';
  [['vc-sticky-price',pt],['vc-mob-price',pt],['vc-sticky-variant',vt],['vc-mob-variant',vt]].forEach(function(x){
    var e=document.getElementById(x[0]);if(e&&x[1])e.textContent=x[1];});
  if(im){var a=document.querySelector('.vc-sticky-bar__thumb');if(a)a.src=im;
    var b=document.querySelector('.vc-mobile-sticky__thumb');if(b)b.src=im;}};

window.vcQty=function(d){var c=Math.max(1,Math.min(20,getQty()+d));setQty(c);
  var s=document.getElementById('vc-sticky-qty');if(s)s.textContent=c;update();};
window.vcATC=function(){var b=atc();if(b)b.click();};

function watch(){
  setInterval(update,300);
  document.addEventListener('input',function(e){if(e.target&&e.target.matches&&e.target.matches('input[name="quantity"],.quantity__input,.js-qty__num'))update();},true);
  document.addEventListener('click',function(e){if(e.target.closest('.quantity__button,.js-qty__adjust,[data-quantity-plus],[data-quantity-minus],quantity-input button'))setTimeout(update,120);},true);
  document.addEventListener('change',function(){setTimeout(vcSync,60);setTimeout(function(){lastSig='';update();},120);});
  document.addEventListener('click',function(e){
    if(e.target.closest('[name="add"],.product-form__submit,button[data-add-to-cart],.wt-button--add-to-cart,.cart-item__quantity,cart-remove-button,[data-cart-remove]'))
      setTimeout(refreshCart,900);},true);
  ['cart:updated','cart:refresh','cart:change','ajaxProduct:added','cart-drawer:open','on:cart:add'].forEach(function(ev){
    document.addEventListener(ev,function(){setTimeout(refreshCart,250);});});
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refreshCart();});
}

function init(){CFG=cfg();loadPrices();var b=atc();if(!b)return;
  var w=b.closest('.product-form__buttons,.product-form__submit-wrapper,.wt-product__buy-buttons')||b.parentElement;
  duties(w);badges(w);trust(w);volbar(w);great(b);sticky();detectCountry();
  if(!window.__vcWatch){window.__vcWatch=1;watch();}}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',function(){setTimeout(init,300);});
document.addEventListener('variant:changed',function(){setTimeout(vcSync,100);setTimeout(function(){lastSig='';update();},150);});
})();
